import image0 from '../assets/progress_bar/progress_bar_0.svg';
import image1 from '../assets/progress_bar/progress_bar_1.svg';
import image2 from '../assets/progress_bar/progress_bar_2.svg';
import image3 from '../assets/progress_bar/progress_bar_3.svg';
import imageActive0 from '../assets/progress_bar/progress_bar_0_active.svg';
import imageActive1 from '../assets/progress_bar/progress_bar_1_active.svg';
import imageActive2 from '../assets/progress_bar/progress_bar_2_active.svg';
import imageActive3 from '../assets/progress_bar/progress_bar_3_active.svg';
import truck from '../assets/progress_bar/truck.svg';
import truckActive from '../assets/progress_bar/truck_active.svg';
import setup from '../assets/progress_bar/setup.svg';
import setupActive from '../assets/progress_bar/setup_active.svg';
import manifest from '../assets/progress_bar/manifest.svg';
import manifestActive from '../assets/progress_bar/manifest_active.svg';

import { ProcessBarTag } from '../models/ProcessBarItem';

const barItems = {
	import: [
		{
			icon: image0,
			activeIcon: imageActive0,
			label: 'Add Airwaybill to cart',
			link: '',
			tag: ProcessBarTag.AWB_LIST
		}, {
			icon: image1,
			activeIcon: imageActive1,
			label: 'Request additional services',
			link: 'cart',
			tag: ProcessBarTag.CART
		}, {
			icon: image2,
			activeIcon: imageActive2,
			label: 'Pay charges due',
			link: 'pay',
			tag: ProcessBarTag.PAYMENT
		}, {
			icon: image3,
			activeIcon: imageActive3,
			label: 'Issue and send pickup order',
			link: 'issue-po',
			tag: ProcessBarTag.ORDER
		}
  ],
  export: [
		{
			icon: image0,
			activeIcon: imageActive0,
			label: 'Add AWBs to List',
			link: 'my-exports',
			tag: ProcessBarTag.AWB_LIST
		}, {
			icon: truck,
			activeIcon: truckActive,
			label: 'Group AWBs for Drop off',
			link: 'truck',
			tag: ProcessBarTag.CART
		}, {
			icon: image3,
			activeIcon: imageActive3,
			label: 'Schedule Drop Off',
			link: 'drop-off-order',
			tag: ProcessBarTag.ORDER
		}
	],
	ghaImport: [
		{
			icon: image0,
			activeIcon: imageActive0,
			label: 'Add Airwaybill to cart',
			link: 'manual-entry-import',
			tag: ProcessBarTag.AWB_LIST
		}, {
			icon: image1,
			activeIcon: imageActive1,
			label: 'Request additional services & Schedule',
			link: 'manual-entry-cart',
			tag: ProcessBarTag.CART
		}, {
			icon: image2,
			activeIcon: imageActive2,
			label: 'Pay charges due',
			link: 'manual-entry-pay',
			tag: ProcessBarTag.PAYMENT
		}, {
			icon: image3,
			activeIcon: imageActive3,
			label: 'Issue and send pickup order',
			link: 'manual-entry-issue-po',
			tag: ProcessBarTag.ORDER
		}
	],
	ghaExport: [
		{
			icon: image0,
			activeIcon: imageActive0,
			label: 'Add AWBs to List',
			link: 'manual-entry-export',
			tag: ProcessBarTag.AWB_LIST
		}, {
			icon: truck,
			activeIcon: truckActive,
			label: 'Group AWBs for Drop off',
			link: 'manual-entry-truck',
			tag: ProcessBarTag.CART
		}, {
			icon: image3,
			activeIcon: imageActive3,
			label: 'Schedule Drop Off',
			link: 'manual-entry-drop-off-order',
			tag: ProcessBarTag.ORDER
		}
	],
	offline: [
		{
			icon: setup,
			activeIcon: setupActive,
			label: 'Set Up RFS',
			link: 'create-rfs',
			tag: ProcessBarTag.AWB_LIST
		}, {
			icon: manifest,
			activeIcon: manifestActive,
			label: 'Create Manifest',
			link: 'create-manifest',
			tag: ProcessBarTag.ORDER
		},
	]
};
  
export default {
	barItems
}